import { useEffect, useState } from "react";
import apiPublic from "../../../../api";
import { getFallbackMakeLogoImage } from "../../utils/carLogo/getFallbackMakeLogoImage";
import { title } from "../../../../assets/jss/material-dashboard-react";

const LogoPage = ({ onLogoClick }) => {
    const [makes, setMakes] = useState([]);
    const [fetchError, setFetchError] = useState(null);

    useEffect(() => {
        const fetchMakes = async () => {
            try {
                const response = await apiPublic.get('/onboarding/makes');
                setMakes(response.data);
            } catch (err) {
                setFetchError('Greška pri učitavanju marki vozila.');
            }
        };

        fetchMakes();
    }, []);

    return (
        <div style={styles.pageContainer}>
            <div style={styles.title}>1/2 Izaberi marku automobila:</div>
            {fetchError && <div>{fetchError}</div>}
            {!makes.length && <div>Učitavanje marki...</div>}
            <div style={styles.container}>
                {makes.map((make, index) => {
                    const logoUrl = getFallbackMakeLogoImage(make.name);
                    return (
                        <div
                            key={index}
                            style={styles.logoContainer}
                            onClick={() => onLogoClick(make)}
                        >
                            <img
                                src={logoUrl}
                                alt={make.name}
                                style={styles.logoImage}
                            />
                            <p style={styles.makeName}>{make.name}</p>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default LogoPage;

const styles = {
    pageContainer: {
        padding: 20
    },
    title: {
        fontSize: 24,
        fontWeight: 'bold',
        margin: '20px 0',
        color: 'black'
    },
    container: {
        display: "flex",
        flexWrap: "wrap",
        gap: 20,
        justifyContent: "center",
    },
    logoContainer: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        width: 150,
        cursor: "pointer",
        transition: "transform 0.2s",
    },
    logoImage: {
        width: 100,
        height: 100,
        objectFit: "contain",
        border: "1px solid #CBD5E1",
        borderRadius: 8,
        backgroundColor: "#f9fafb"
    },
    makeName: {
        marginTop: 10,
        fontSize: 16,
        textAlign: "center"
    }
};
